import { motion } from "framer-motion";

const LOGO =
  "https://customer-assets.emergentagent.com/job_gower-golf-portal/artifacts/mrpoga90_ChatGPT%20Image%20May%2029%2C%202026%2C%2008_00_01%20PM.png";

const HEADER_BG =
  "https://customer-assets.emergentagent.com/job_gower-golf-portal/artifacts/52cr0i65_ChatGPT%20Image%20May%2029%2C%202026%2C%2010_27_03%20PM.png";

export default function Header() {
  return (
    <header
      data-testid="grand-header"
      className="relative bg-white pt-20 md:pt-24 pb-20 md:pb-28 overflow-hidden"
      style={{ isolation: "isolate" }}
    >
      {/* Full original golf landscape — full-width, complete image, fades smoothly into white */}
      <div
        className="absolute inset-x-0 top-0 h-[120%] pointer-events-none"
        aria-hidden="true"
        style={{
          left: "50%",
          transform: "translateX(-50%)",
          width: "100vw",
          WebkitMaskImage:
            "linear-gradient(to bottom, #000 0%, #000 60%, rgba(0,0,0,0.6) 82%, rgba(0,0,0,0) 100%)",
          maskImage:
            "linear-gradient(to bottom, #000 0%, #000 60%, rgba(0,0,0,0.6) 82%, rgba(0,0,0,0) 100%)",
        }}
      >
        <img
          src={HEADER_BG}
          alt=""
          className="w-full h-full object-cover"
          style={{ objectPosition: "50% 0%" }}
        />
      </div>

      <div className="relative max-w-6xl mx-auto px-6 md:px-12 text-center">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="inline-block section-eyebrow mb-2 bg-white/90 backdrop-blur-sm px-5 py-2 border border-[#CBA153]/40"
        >
          The Gower Peninsula · Swansea · South Wales
        </motion.p>

        <div
          className="mx-auto mb-6 md:mb-8 w-[360px] sm:w-[480px] md:w-[620px] lg:w-[760px] flex items-center justify-center animate-fade-in"
          data-testid="club-logo-wrap"
        >
          <img
            src={LOGO}
            alt="The Gower Golf Club official logo"
            className="w-full h-auto object-contain block"
          />
        </div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.2 }}
          className="sr-only"
          data-testid="club-name-heading"
        >
          The Gower Golf Club — GOLF IN OUTSTANDING NATURAL BEAUTY, Swansea, South Wales
        </motion.h1>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.9, delay: 0.45 }}
          className="mt-10 flex flex-col items-center gap-4"
        >
          <div className="inline-flex items-center gap-3 bg-white/90 backdrop-blur-sm px-6 py-2.5 border border-[#CBA153]/60 shadow-[0_4px_18px_rgba(15,76,58,0.12)]">
            <span className="block w-8 h-px bg-gradient-to-r from-transparent via-[#AA771C] to-[#D4AF37]" />
            <span className="text-gold-metallic text-[11px] tracking-[0.32em] uppercase">
              GOLF IN OUTSTANDING NATURAL BEAUTY
            </span>
            <span className="block w-8 h-px bg-gradient-to-r from-[#D4AF37] via-[#AA771C] to-transparent" />
          </div>
          <p
            className="text-[#1A1A1A] text-sm md:text-base tracking-[0.32em] uppercase bg-white/85 backdrop-blur-sm px-5 py-1 border border-[#CBA153]/30"
            data-testid="club-subtitle"
          >
            Swansea · South Wales
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.6 }}
          className="mt-12 max-w-3xl mx-auto"
        >
          <div className="bg-white/85 backdrop-blur-md border border-[#CBA153]/40 px-7 py-7 md:px-10 md:py-9 shadow-[0_10px_40px_rgba(15,23,42,0.08)]">
            <h2 className="font-serif-luxury text-2xl md:text-3xl text-[#0F172A] tracking-tight leading-snug">
              Welcome to <span className="text-[#0F4C3A]">The Gower Golf Club</span>
            </h2>
            <p className="mt-4 text-[#111827] text-base md:text-[17px] leading-[1.7] font-medium">
              Set within the natural beauty of the Gower Peninsula, we offer memorable golf,
              quality accommodation, and a warm Welsh welcome.
            </p>
          </div>
        </motion.div>
      </div>

      {/* Decorative gold rule */}
      <div className="relative max-w-7xl mx-auto mt-20 px-12">
        <div className="h-px bg-gradient-to-r from-transparent via-[#CBA153] to-transparent opacity-60" />
      </div>
    </header>
  );
}
